import { ENTITIES, USERS } from "../../actions/actionConstants.js";
import { AT_TYPES } from "../../../constants/entity.js";
import { getEntities } from "../../actions/actionUtils.js";

const createInvite = (id, type, user) => {
  const payload = {
    "@type": type, // required by the saga to derive the actionEntity type
    endpoint: `${id}/users`,
    parent: id, // bit of a hack to enable full workstation refresh as POST now returns @type USER objects
    users: [user]
  };

  return {
    type: USERS.POST,
    payload
  };
};

export const createResourceInviteByEmail = (id, type, email, group, sudo) => {
  const inviteUser = {
    "@type": AT_TYPES.INVITEE,
    group,
    email,
    sudo
  };

  return createInvite(id, type, inviteUser);
};

export const createResourceInviteByExistingUser = (id, type, user, sudo) => {
  const inviteUser = {
    "@type": AT_TYPES.INVITEE,
    user,
    sudo
  };

  return createInvite(id, type, inviteUser);
};

export const createProjectInvite = (id, type, email, group) => {
  const inviteUser = {
    "@type": AT_TYPES.INVITEE,
    group,
    email
  };

  return createInvite(id, type, inviteUser);
};

export function getUser(atId, dependencies) {
  return getEntities(ENTITIES, atId, dependencies);
}
